import React from 'react';
import reactDom from '../../../common/react/dom/index';
import BpDemoContainer from '../../../components/frontend/bpdemo';

export default function init() {
	reactDom(<BpDemoContainer />, 'js-react-bpdemo');
}
